import styled from "styled-components";

export const AutocompleteContainer = styled.div`
  top: 100%;

  ${({ isFocused, isAnchored }) => `
    display:  ${isFocused ? "flex" : "none"};

    @media only screen and (max-width: 767px) {
      top: ${isAnchored ? `calc(2rem + 100%)` : "100%"};
    }
  `}

  position: absolute;
  left: 0;
  right: 0;
  z-index: 7;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 0 0 7px 7px;
  background-color: white;
`;

export const SuggestionSearchIcon = styled.button`
  -webkit-appearance: button;
  border: none;
  height: 15px;
  width: 15px;
  margin-right: 10px;

  background: transparent;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg fill='currentColor' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50 50' width='50px' height='50px'%3e%3cpath d='M 21 3 C 11.621094 3 4 10.621094 4 20 C 4 29.378906 11.621094 37 21 37 C 24.710938 37 28.140625 35.804688 30.9375 33.78125 L 44.09375 46.90625 L 46.90625 44.09375 L 33.90625 31.0625 C 36.460938 28.085938 38 24.222656 38 20 C 38 10.621094 30.378906 3 21 3 Z M 21 5 C 29.296875 5 36 11.703125 36 20 C 36 28.296875 29.296875 35 21 35 C 12.703125 35 6 28.296875 6 20 C 6 11.703125 12.703125 5 21 5 Z'/%3e%3c/svg%3e");
  background-size: contain;
  background-repeat: no-repeat;

  cursor: pointer;
`;

export const SuggestionContainer = styled.ul`
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: calc(100% - 1rem);

  @media only screen and (max-width: 767px) {
    max-width: calc(100% - 0.5rem);
  }
`;

export const SuggestionItem = styled.li`
  display: flex;
  align-items: center;
  width: 100%;
  height: 2.5rem;
  list-style-type: none;
  cursor: pointer;
  padding: 0rem 0.5rem;
  font-size: 13px;
  margin: 10px 0px;

  :hover {
    background-color: rgb(245, 245, 245);
  }

  @media only screen and (max-width: 767px) {
    font-size: 12px;
    padding: 0 0.25rem;
  }

  @media only screen and (max-width: 480px) {
    font-size: 11px;
    margni: 7px 0;
  }
`;

export const SuggestionsDivider = styled.div`
  border-top: 1px solid rgb(230, 230, 230);
  margin: 0 1.5rem;
`;
